import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class ValuacionService {

  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }


  post(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/post' ;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  ejecutarValuacion(idEmp: number, idSuc: number, mes: number, anio: number): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/ejecutar/valuacion/' + idEmp + '/' + idSuc + '/' + mes + '/' + anio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  catalogo(criterio: any): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/valuacion-moneda-extranjera/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  get(id: number): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getTc(moneda: String, idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/ctb_tc/get/' + moneda + '/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  monedas(idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/valuacion-moneda-extranjera/monedas/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
